export default {
  ACTION_RESEND_EMAIL: 'ACTION_RESEND_EMAIL'
};



// WEBPACK FOOTER //
// ./src/store/modules/emailHistory/constants.js